import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import CringeShell from './CringeShell';
import { GameHead, Popup, RotateNotice, TopBar, useSaveScore } from './common';
import { useGameTimer, useRotateNotice } from './hooks';
import { initPipeGame } from './pipeGame';

const RULES = [
  'Your objective is to connect the dots of same colour.',
  'Only condition is NO colour pipe should overlap one another.',
  'Find a different route for each pipe.',
  'To revert back to the dot of the same color, click on the dot where you first started.',
];
const RULES_SHOWN = 'cringe.rulesShown'; // flow.php showed the rules once per PHP session

function firstVisit() {
  try {
    if (sessionStorage.getItem(RULES_SHOWN)) return false;
    sessionStorage.setItem(RULES_SHOWN, '1');
  } catch {
    /* storage unavailable: show them */
  }
  return true;
}

function Stage4Game() {
  const navigate = useNavigate();
  const { search } = useLocation();
  const game = useSelector((s) => s.cringe.game);
  const timer = useGameTimer(true, game?.time);
  const rotate = useRotateNotice();
  const save = useSaveScore();
  const gridRef = useRef(null);
  const [round, setRound] = useState(0); // Reset rebuilds the board (flow.php reloaded the page)
  const [solved, setSolved] = useState(false);
  const [rules, setRules] = useState(firstVisit);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    setSolved(false);
    return initPipeGame(gridRef.current, setSolved);
  }, [round]);

  // Submit = solved (1 point), Skip = 0 points; both show a message and go on to stage 5.
  const finish = async (score, text) => {
    if (busy) return;
    setBusy(true);
    const state = await save(4, score, timer.current());
    if (state) setMessage(text);
    else setBusy(false);
  };

  return (
    <>
      {rotate && <RotateNotice />}
      <TopBar time={timer.text} points={game?.totalScore || 0}>
        <button type="button" className="cr-rules-btn" onClick={() => setRules(true)}>Rules to Play</button>
      </TopBar>
      <div className="cr-stage-body cr-stage4-body">
        <GameHead>
          Cringe has a cringe-full way of ruining the holiday spirit! Untangle a string of holiday lights to bringing
          back light to Frostvale.
        </GameHead>
        <div className="cr-pipe-wrap">
          <div className="cr-pipe-grid" ref={gridRef} />
        </div>
        <div className="cr-pipe-actions">
          <button type="button" className="cr-btn" onClick={() => setRound((r) => r + 1)} disabled={busy}>Reset</button>
          {solved && (
            <button type="button" className="cr-btn" onClick={() => finish(1, 'That was spectacular! Wasn’t it!')} disabled={busy}>
              Submit
            </button>
          )}
          <button
            type="button"
            className="cr-btn cr-btn-red"
            onClick={() => finish(0, 'Oh no, is Cringe secretly watching you fail? Don’t let him win!')}
            disabled={busy}
          >
            Skip
          </button>
        </div>
      </div>

      {rules && (
        <div className="cr-overlay" onClick={() => setRules(false)}>
          <div className="cr-rules" style={{ backgroundImage: 'url(/cringe/img/stage4/popup-rules.jpg)' }} onClick={(e) => e.stopPropagation()}>
            <h5>Rules</h5>
            <ul>
              {RULES.map((r) => (
                <li key={r}>{r}</li>
              ))}
            </ul>
            <button type="button" className="cr-rules-close" onClick={() => setRules(false)}>Close</button>
          </div>
        </div>
      )}

      {message && (
        <Popup onClose={() => navigate({ pathname: '/stage5', search })}>
          <h2>{message}</h2>
        </Popup>
      )}
    </>
  );
}

// PipeGame/flow.php: untangle the lights — connect every pair of dots and fill the board (1 point) or skip (0).
export default function CringeStage4() {
  return (
    <CringeShell bg="stage4/stage4_desk.png" bgMob="stage4/stage4_mob.png" stage={4} className="cr-stage cr-stage4">
      <Stage4Game />
    </CringeShell>
  );
}
